import { render, staticRenderFns } from "./FormHeading.vue?vue&type=template&id=b0ca9c0a"
import script from "./FormHeading.vue?vue&type=script&lang=js"
export * from "./FormHeading.vue?vue&type=script&lang=js"
import style0 from "./FormHeading.vue?vue&type=style&index=0&id=b0ca9c0a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports